import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface FaqDto {
  id: number;
  question: string;
  answer: string;
}

interface FaqApiResponse {
  success: boolean;
  message: string;
  pagination: {
    pages: number;
    perPage: number;
    currentPage: number;
    totalObjects: number;
  };
  faqs: FaqDto[];
}

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private apiUrl = environment.baseHref + 'api/v1/';

  constructor(private http: HttpClient) {}

  getFaqs(page: number = 1, pageSize: number = 10): Observable<FaqApiResponse> {
    return this.http
      .get<FaqApiResponse>(`${this.apiUrl}faq-service/faqs`, {
        params: {
          page: String(page),
          pageSize: String(pageSize)
        }
      })
      .pipe(
        map((response: FaqApiResponse) => {
          if (!response) {
            return {
              success: false,
              message: 'Failed to load FAQs',
              pagination: {
                pages: 0,
                perPage: pageSize,
                currentPage: page,
                totalObjects: 0
              },
              faqs: []
            };
          }
          return response;
        })
      );
  }
}
